/**
 * Is Online.
 */
window.isOnline = function() {
    if (window.navigator.onLine) {
        setOnline();
    } else {
        setOffline();
    }
};

/**
 * Set Offline.
 */
window.setOffline = function() {
    $('.alert-offline').show();
    $('.btn').each(function(k, button) {
        if (!$(button).is(":disabled")) {
            $(button)
                .attr('disabled', true)
                .addClass('button-offline');
        }
    });
};

/**
 * Set Online.
 */
window.setOnline = function() {
    $('.alert-offline').hide();
    $('.button-offline')
        .attr('disabled', false)
        .removeClass('button-offline');
};

/**
 * Check Online.
 * @returns {Promise<boolean>}
 */
let pendingOnlineCheck = null;
let lastOnlineCheckAt = 0;

const onlineCheckInterval = 60000;
const onlineCheckTimeout = 3000;

window.checkOnline = async function(options = {}) {
    const force = options.force === true;

    if (!window.navigator.onLine) {
        setOffline();
        return false;
    }

    if (environment === "local") {
        setOnline();
        return true;
    }

    if (document.hidden && !force) {
        return true;
    }

    const now = Date.now();

    if (!force && now - lastOnlineCheckAt < onlineCheckInterval) {
        return true;
    }

    if (pendingOnlineCheck) {
        return pendingOnlineCheck;
    }

    lastOnlineCheckAt = now;

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), onlineCheckTimeout);
    const url = new URL('/favicon.ico', window.location.origin);

    pendingOnlineCheck = fetch(url.toString(), {
        method: 'HEAD',
        cache: 'no-store',
        credentials: 'same-origin',
        signal: controller.signal,
    })
        .then((response) => {
            if (response.ok) {
                setOnline();
                return true;
            }

            setOffline();
            return false;
        })
        .catch(() => {
            setOffline();
            return false;
        })
        .finally(() => {
            clearTimeout(timeout);
            pendingOnlineCheck = null;
        });

    return pendingOnlineCheck;
}

window.addEventListener('offline', () => {
    setOffline();
});

window.addEventListener('online', () => {
    setOnline();
    checkOnline({ force: true });
});

window.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
        checkOnline();
    }
});

window.addEventListener('load', () => {
    isOnline();
    checkOnline();
});
